import { adminMetaContract } from './admin-meta.js';
import { adminContract, invitesContract } from './auth.js';
import { catalogContract, mediaContract } from './catalog.js';
import { collectionsContract, locationsContract, savedFiltersContract, specimensContract, statsContract, tagsContract, counterpartiesContract, } from './collections.js';
import { healthContract } from './health.js';
import { ioContract } from './io.js';
import { metaContract } from './meta.js';
import { numistaContract } from './numista.js';
import { profileContract } from './profile.js';
import { publicShareContract, sharesContract } from './shares.js';
import { refsContract } from './refs.js';
export * from './admin-meta.js';
export * from './auth.js';
export * from './catalog.js';
export * from './collections.js';
export * from './common.js';
export * from './filter.js';
export * from './health.js';
export * from './io.js';
export * from './meta.js';
export * from './numista.js';
export * from './profile.js';
export * from './shares.js';
export * from './refs.js';
/**
 * Полный контракт API. Единственный источник правды для реализации в NestJS,
 * типизированного клиента и OpenAPI (docs/PLAN.md, раздел 1.1).
 * Эндпоинты аутентификации (/api/auth/*) обслуживает Better Auth — они вне контракта.
 */
export const contract = {
    health: healthContract,
    invites: invitesContract,
    admin: adminContract,
    meta: metaContract,
    ref: refsContract,
    catalog: catalogContract,
    media: mediaContract,
    collections: collectionsContract,
    locations: locationsContract,
    specimens: specimensContract,
    tags: tagsContract,
    counterparties: counterpartiesContract,
    savedFilters: savedFiltersContract,
    stats: statsContract,
    numista: numistaContract,
    profile: profileContract,
    shares: sharesContract,
    publicShare: publicShareContract,
    io: ioContract,
    adminMeta: adminMetaContract,
};
//# sourceMappingURL=index.js.map